import React, { useState, useEffect } from "react";
import { Tag, Button } from "antd";
import { WifiOutlined } from "@ant-design/icons";

export const InformfixStatus = (props) => {
  const [fontcolor, setFontColor] = useState();

  useEffect(() => {
    switch (props.statusId) {
      case -2:
        setFontColor("red");
        break;
      case -1:
        setFontColor("red");
        break;
      case 1:
        setFontColor("#068a1a");
        break;
      case 2:
        setFontColor("#068a8a");
        break;
      case 3:
        setFontColor("#797a7a");
        break;
    }
  });
  return (
    <React.Fragment>
      <span
        style={{
          minWidth: "100%",
          fontWeight: 500,
          textAlign: "center",
          color: fontcolor,
        }}
      >
        {<WifiOutlined />} {props.name}
      </span>
    </React.Fragment>
  );
};
